// import { useReactiveVar } from "@apollo/client";
import { Box, BoxProps, Divider, Stack, VStack } from "@chakra-ui/react";
import { Field, FieldProps, FormikProps, FormikValues } from "formik";
import { DatePicker } from "../../../components/datePicker/DatePicker";
import { FormFieldLabel } from "../../../components/formFieldLabel/FormFieldLabel";
import { FormInputField } from "../../../components/formInputField/FormInputField";
import { FormSubSectionHeader } from "../../../components/formSubSectionHeader/FormSubSectionHeader";
import { IFormDataClassField } from "../../../utils/formsSchema/FormDataClass";

interface Props {
  fields: Record<string, IFormDataClassField>;
  formik: FormikProps<FormikValues>;
  defaultValues: Record<string, any>;
}

export const SegmentDetails = ({
  formik,
  fields,
  defaultValues,
  ...boxProps
}: Props & BoxProps) => {
  const {
    name,
    startDate,
    endDate,
    // expansionCategories
  } = fields;

  // const currentUser = useReactiveVar(userDetailsVar);
  // const precisionCategoriesList = usePrecisionCategoriesOptions();
  // const [selectedExpansionOptions, setSelectedExpansionOptions] = useState<
  //   CheckboxOptionType[]
  // >([]);

  // useEffect(() => {
  //   const expansionIds = selectedExpansionOptions.map((option) => option.id);
  //   formik.setFieldValue("expansionCategories", expansionIds);
  // }, [selectedExpansionOptions]);

  return (
    <Box bg={"white"} borderRadius={"xs"} {...boxProps}>
      <FormSubSectionHeader label={"Segment Details"} />
      <Divider mt={0} mb={4} />
      <Stack align={"flex-start"} width={"100%"} direction="row">
        <VStack w="100%">
          <Field name={"name"}>
            {({ field, form }: FieldProps) => (
              <FormInputField
                mt={0}
                inputFieldProps={{
                  ...field,
                  variant: "greyInput",
                }}
                fieldType={"text"}
                isRequired={name.isRequired}
                label={name.label}
                isInvalid={!!(form.errors.name && !!form.touched.name)}
                placeholder={name.placeholder}
                errorMessage={form.errors?.name?.toString()}
              />
            )}
          </Field>
          <Field name={"startDate"}>
            {({ field, form }: FieldProps) => {
              return (
                <FormFieldLabel
                  label={startDate.label}
                  isRequired={startDate.isRequired}
                  errorMessage={form.errors?.startDate?.toString()}
                  isInvalid={
                    !!(form.errors["startDate"] && !!form.touched["startDate"])
                  }
                >
                  <DatePicker
                    inputProps={{ field, form, variant: "greyInput" }}
                    placeholder={startDate.placeholder}
                    dateLimits={{ start: new Date() }}
                  />
                </FormFieldLabel>
              );
            }}
          </Field>

          <Field name={"endDate"}>
            {({ field, form }: FieldProps) => {
              return (
                <FormFieldLabel
                  // toolTip={"Leave end date empty if segment will always be on."}
                  label={endDate.label}
                  isRequired={endDate.isRequired}
                  errorMessage={form.errors?.endDate?.toString()}
                  isInvalid={
                    !!(form.errors["endDate"] && !!form.touched["endDate"])
                  }
                >
                  <DatePicker
                    inputProps={{ field, form, variant: "greyInput" }}
                    placeholder={endDate.placeholder}
                    dateLimits={{ start: new Date() }}
                    tooltipText={
                      "Leave end date empty if segment will always be on."
                    }
                  />
                </FormFieldLabel>
              );
            }}
          </Field>
        </VStack>
          {/* <Field name={"precisionCategories"}>
            {({ field, form }: FieldProps) => {
              const onMenuClose = () => {
                form.setFieldTouched(field.name, true, true);
              };

              return (
                <FormFieldLabel
                  mt={0}
                  label={expansionCategories.label}
                  isRequired={expansionCategories.isRequired}
                  isInvalid={
                    !!(
                      form.errors["expansionCategories"] &&
                      !!form.touched["expansionCategories"]
                    )
                  }
                  errorMessage={form.errors?.expansionCategories?.toString()}
                  // toolTipComponent={<PrecisionCategoriesToolTip />}
                >
                  <DropdownCheckboxTree
                    checkboxOptions={
                      precisionCategoriesList.precisionCategoriesOptions
                    }
                    selectedOptions={selectedExpansionOptions}
                    setSelectedOptions={setSelectedExpansionOptions}
                    onPopoverClose={onMenuClose}
                    limitOptions={4} // Upto tier 4
                    handleChildren={true}
                    handleParents={true}
                    inputVariant="greyInput"
                    tagVariant="below"
                  />
                </FormFieldLabel>
              );
            }}
          </Field> */}
      </Stack>
    </Box>
  );
};
